import React from 'react'
import PropTypes from 'prop-types'
import moment from '../../../../helpers/moment'

export default class ShiftEditRow extends React.Component {
  onChange(e) {
    this.item[e.target.name] = e.target.value
    this.item.changed = true
    this.props.onChange(this.item)
  }
  onChangeTime(e) {
    this.item.startEdit = moment(this.props.item.startEdit).startOf('day').add(moment.duration(e.target.value)).toISOString()
    this.item.changed = true

    const selectedTimes = this.props.selectedTimes
    if (selectedTimes && selectedTimes.filter(t => moment(this.item.startEdit).isSame(t)).length > 0) {
      this.item.inValid = true
    }
    else {
      this.item.inValid = false
    }

    this.props.onChange(this.item)
  }
  delete() {
    this.item.deleted = !this.item.deleted
    this.item.changed = true
    this.props.onChange(this.item)
  }
  render() {
    const { startEdit, activeDrivers, deleted, changed, newShift } = this.props.item
    const { currentShift } = this.props
    this.item = { ...this.props.item } // Copy item so we don't mutate on changes
    let validCss = this.item.inValid ? ' is-invalid' : ''

    return <tr className={(deleted && 'table-danger') || (newShift && 'table-success') || (changed && 'table-warning') || ''}>
      <td >
        <div className="input-group">
          {currentShift && <div className="input-group-prepend">
            <label className="input-group-text" htmlFor="inputGroupSelect01" >
              <span className="fa fa-star" aria-hidden="true" />
              <span className="sr-only">Current shift start time</span>
            </label>
          </div>}
          <input type="time" name="startEdit" className={'form-control form-control-sm' + validCss} disabled={deleted}
            onChange={this.onChangeTime.bind(this)} value={moment(startEdit).format('HH:mm')} />
        </div>
      </td>
      <td>
        <input type="number" disabled={deleted} className="form-control form-control-sm" name="activeDrivers" min="0" step="1" value={activeDrivers} onChange={e => this.onChange(e)} />
      </td>
      <td>
        <button name="RemoveShift" type="submit" className="btn btn-sm btn-secondary btn-sm" onClick={() => this.delete()}>{deleted ? 'Undo' : 'Remove'}</button>
      </td>
    </tr>
  }
}

ShiftEditRow.propTypes = {
  item: PropTypes.object.isRequired,
  selectedTimes: PropTypes.array,
  currentShift: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/shifts/shiftEditRow.js